import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";

import { Button } from "../../UI/Button";
import { MigrationField } from "../../services/PortfolioApi";
import { LegacyFieldValue } from "./useImportMigrationWizard";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

interface LegacyFieldsProps {
  fields: MigrationField[];
  values: Record<string, LegacyFieldValue>;
  onChange: (name: string, value: LegacyFieldValue) => void;
}

export const LegacyFields: React.FC<LegacyFieldsProps> = ({ fields, values, onChange }) => (
  <>
    {fields.map((field, index) => {
      const value = values[field.fieldName];
      const type = field.fieldType.toLowerCase();

      if (type === "file") {
        const selectedFile = value instanceof File ? value : null;
        return (
          <Grid item key={`${field.fieldName}-${index}`}>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <label
                style={{
                  fontSize: 12,
                  color: "#6B778C",
                  fontWeight: 600,
                  textTransform: "uppercase",
                }}
              >
                {field.fieldName} (CSV)
              </label>
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <Button component="label" appearance="primary">
                  {selectedFile ? "Change file" : "Choose CSV file"}
                  <VisuallyHiddenInput
                    type="file"
                    accept=".csv"
                    onChange={(e) => {
                      const f = e.target.files?.[0] ?? null;
                      onChange(field.fieldName, f);
                    }}
                  />
                </Button>
                {selectedFile && (
                  <span style={{ fontSize: 14, color: "#172B4D" }}>{selectedFile.name}</span>
                )}
              </div>
            </div>
          </Grid>
        );
      }

      return (
        <Grid item key={`${field.fieldName}-${index}`}>
          <TextField
            fullWidth
            label={field.fieldName}
            value={value == null ? "" : String(value)}
            type={type === "number" ? "number" : "text"}
            onChange={(e) => onChange(field.fieldName, e.target.value)}
            required
          />
        </Grid>
      );
    })}
  </>
);
